<template lang="pug">
  .collapse-wrapper
    .header
      lei-popover(:text="tip", placement="right")
        slot(name="title")
          label.title {{title}}
      lei-popover(:text="tooltips.hideBtn")
        a.toggle(@click="$emit('toggle')") {{ showContent ? 'Hide' : 'Show'}}
    transition(name="collapse")
      .content(v-show="showContent")
        slot
</template>
<script>
import LeiPopover from '../lei-components/LeiPopover'
import record from '../../constants/tooltips/record'

export default {
  components: {
    LeiPopover,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    showContent: {
      type: Boolean,
      default: true,
    },
    tip: {
      type: Object,
      default: () => ({
        small: '',
        full: '',
      }),
    },
  },
  data () {
    return {
      tooltips: record,
    }
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../assets/styles/variables.styl"
  .collapse-wrapper
    display flex
    flex-direction column
    width 100%

    .header
      width 100%
      justify-content space-between
      align-items center
      display flex
      padding 15px 0
      border-bottom 5px solid $default-color-light-1
      margin-bottom 20px

      .title
        color $default-color-bold
        font-weight 600

        &.lei-code
          display flex
          align-items center

      .toggle
        color $default-color-bold
        font-weight 600
        text-decoration none
        border-bottom 1px solid $turquoise-color
        padding-bottom: 3px;

        &:hover
          color $turquoise-color

    .content
      transform-origin top
      height auto
      transition transform .15s cubic-bezier(1.0, 0.5, 0.8, 1.0)

  .collapse-enter-active
    transform scaleY(1)

  .collapse-enter, .collapse-leave-to
    transform scaleY(0)

  @media screen and (max-width: $laptop-l)
    .collapse-wrapper
      .header
        max-width auto

      .content
        max-width auto

  @media screen and (max-width: $tablet)
    .collapse-wrapper
      .header
        padding 15px 20px
        border-bottom 1px solid $default-color-light-1
        margin-bottom 0
</style>



// WEBPACK FOOTER //
// src/components/lei-components/CollapseComponent.vue